import "@hakili/ui/styles.css";

import { createRoot } from "react-dom/client";

import { App } from "./App.js";

/**
 * The entry point of `client-web`, `P0-UIK-020`.
 *
 * **What this file does, and what it deliberately does not.** It finds the
 * mount point and opens a React root on it. That is the whole of it, and the
 * restraint is the point rather than an omission.
 *
 * This item's scope is *"a bundler, an entry point and a `build` script per
 * app"* , the machinery that turns a component tree into something a static
 * host can serve. It is NOT the wiring of le client's screens. `ClientShell`
 * takes required props, and inventing values for them here would be writing
 * product inside an infrastructure item: a router, a session gate and a role
 * whitelist would all have to be guessed, and each is owned by a screen item
 * that names its own workflow ids.
 *
 * **Round 178 is when those items landed.** `P1-CLI-001` to `P1-CLI-003` build
 * WF-CLI-01, WF-CLI-02 and the buyer's own file, so this entry now mounts them ,
 * exactly as `020` said it would: *"they replace this body , not this file's
 * existence."*
 */
const racine = document.querySelector("#racine");
if (racine === null) {
  // Not a silent no-op: a missing mount point means the entry document and the
  // entry script disagree, and the page would be blank with nothing in the
  // console to say why.
  throw new Error("racine introuvable");
}

createRoot(racine).render(<App origin={import.meta.env.VITE_API_ORIGIN} />);
